<div class="container awards">
  <div class="ptb-90">
    <div class="d-flex align-items-center justify-content-between">
      <div>
        <img src="assets/images/company/awards/worlds-most-ethical-2024-10x-180px.png" class="mw-100 padding-lr-20"
             alt="World's Most Ethical Companies award logo">
      </div>

      <div><img src="assets/images/sustainability/worlds-most-sustainable-corps-green-2024.png" class="mw-100 padding-lr-20" alt="Worlds Most Sustainable Corporations"></div>

      <div>
        <img src="assets/images/awards/time-most-influential-companies.png" class="mw-100 padding-lr-20"
             alt="Great Place To Work Certification logo">
      </div>
    </div>
  </div>
</div>
